import area from '@turf/area';
import { FcPermissionCode, Permission } from '@fc-core';

export const toCamel = (value: string): string => {
  return value.replace(/([-_][a-z])/gi, ($1) => {
    return $1.toUpperCase().replace('-', '').replace('_', '');
  });
};

export function copyToClipboard(text: string) {
  navigator.clipboard.writeText(text);
}

export const getVersion = (): string | undefined => {
  const version = document
    .querySelector('meta[name="app-version"]')
    ?.getAttribute('content');
  if (!version || version.startsWith('${')) return undefined;
  return version;
};

export function hashStringToColor(str: string): string {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  let colour = '#';
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xff;
    colour += value.toString(16).padStart(2, '0');
  }
  return colour;
}

export const getLocationArea = (feature: any): number => {
  return Math.round(area(feature) * 10.764); // Return feet square
};

export const highlightSearch = (search: string, fullText: string): string => {
  if (!search) return fullText;
  search = search?.trim().replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  return fullText.replace(
    new RegExp(search, 'gi'),
    (match) => `<span class="search-highlight">${match}</span>`,
  );
};

export const hasPermission = (
  permissionList: Permission[],
  codename: FcPermissionCode,
): boolean => {
  return permissionList
    .map((permission) => permission.codename)
    .includes(codename);
};

export const generateRandomString = (length: number): string => {
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  return Array.from({ length })
    .map(() => characters.charAt(Math.floor(Math.random() * characters.length)))
    .join('');
};

export const generateRandomNumber = (length: number): number => {
  return Math.floor(Math.random() * 10 ** length);
};

export const generateId = (): number => {
  return generateRandomNumber(4);
};

export function blobToBase64(blob: Blob): Promise<string | ArrayBuffer> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => resolve(reader.result ?? '');
    reader.onerror = reject;
  });
}

export const sleep = (ms: number) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};
